import "react-loading-skeleton/dist/skeleton.css";

import { usePatientConsents } from "@/api2/Consent/queries/usePatientConsents";
import type { Profile } from "@/core/types";
import type { UUID } from "@/core/types";

import { MemberProfileACPSection } from "../MemberProfileACPSection/MemberProfileACPSection";
import MemberProfileConsentList from "../MemberProfileConsentList";
import MemberProfilePolicyList from "../MemberProfilePolicyList";

import { MemberProfileConsentsSectionSkeleton } from "./MemberProfileConsentsSectionSkeleton";

type MemberProfileConsentsSectionProps = {
  insuranceCarrier: string;
  patientGroupType?: Profile["group_type"];
  patientId: UUID;
};

export function MemberProfileConsentsSection({
  insuranceCarrier,
  patientGroupType,
  patientId,
}: MemberProfileConsentsSectionProps) {
  const { data: consents, isLoading } = usePatientConsents(patientId);

  const isTeensAndKidsProgram = patientGroupType === "teens_kids_program";

  if (isLoading || !consents) return <MemberProfileConsentsSectionSkeleton />;

  return (
    <>
      {!isTeensAndKidsProgram && (
        <MemberProfileACPSection consents={consents} insuranceCarrier={insuranceCarrier} />
      )}
      <MemberProfilePolicyList consents={consents} patientId={patientId} />
      <MemberProfileConsentList consents={consents} patientId={patientId} />
    </>
  );
}
